import React from "react";
import calltoaction from "../scss/telegramexpo1-01.png";

const Header = () => {
  return (
    <div className="header">
      <p className="introducing">Introducing <br className="header-separator" />FreeMinder for Telegram</p>
    </div>
  );
};

export default Header;
